import { z } from 'zod';

import { AgentIdSchema } from '../agent/agent';

/**
 * Outcome of a card closure. Spec v4 §Card.closure:
 * - `resolved` — the case ended successfully (work done, customer satisfied).
 * - `cancelled` — the case ended without delivering value (duplicate, customer
 *   gave up, request abandoned).
 */
export const ClosureOutcomeSchema = z.enum(['resolved', 'cancelled']);

export type ClosureOutcome = z.infer<typeof ClosureOutcomeSchema>;

/**
 * Card closure record. When `closure !== null` the card is closed; otherwise
 * open. Any agent (`ai` | `human`) may close a card — `closedBy` is a bare
 * {@link AgentIdSchema} so the value can be parsed without coupling to the
 * `AgentSchema` discriminated union; the agent kind is resolved via the
 * `agents` collection when needed.
 */
export const ClosureSchema = z.object({
  closedAt: z.coerce.date(),
  outcome: ClosureOutcomeSchema,
  closedBy: AgentIdSchema,
  reason: z.string().max(2000).optional(),
});

export type Closure = z.infer<typeof ClosureSchema>;
